// List of all weather stations
import Leaflet from "leaflet";

//#region temperature icon maker and corresponding color function
export function humMarker(hum: string): Leaflet.DivIcon {
  if (hum === "M") {
    return Leaflet.divIcon({
      className: "number-icon",
      html: `<div style="background-color: gray; margin: 0px; color: white;">${hum}</div>`,
      iconSize: setHumIconSize(hum),
    });
  }

  return Leaflet.divIcon({
    className: "number-icon",
    html: `<div style="background-color: ${setColorOfHum(
      hum
    )}; margin: 0px; color:${setColorOfHumText(hum)};">${hum + "%"}</div>`,
    iconSize: setHumIconSize(hum),
  });
}

function setColorOfHum(hum: string): string {
  var humFloat: number = parseFloat(hum);

  switch (true) {
    case humFloat >= 95.0:
      return "#0064ff";
    case humFloat >= 85.0:
      return "#00ded1";
    case humFloat >= 70.0:
      return "#d6cd00";
    case humFloat >= 40.0:
      return "orange";
    case humFloat >= 0.0:
      return "red";
    default:
      return "gray";
  }
}

function setColorOfHumText(hum: string): string {
  var humFloat: number = parseFloat(hum);

  switch (true) {
    case humFloat >= 95.0:
      return "white";
    case humFloat >= 40.0:
      return "black";
    case humFloat >= 0.0:
      return "white";
    default:
      return "black";
  }
}

function setHumIconSize(humStr: string): Leaflet.PointExpression {
  switch (true) {
    case humStr?.length === 1:
      return [21, 25];
    case humStr?.length === 2:
      return [34, 25];
    case humStr?.length === 3:
      return [38, 25];
    default:
      return [38, 25];
  }
}
//#endregion
